import { alto, Button } from '@parchment/atoms';
import { CancelIcon } from '@parchment/icons';
import React from 'react';
import styled, { css } from 'styled-components';
const ModalTitle = _ref => {
  let {
    title,
    headerIcon,
    defaultIcon,
    closeable,
    ariaLabel,
    headerId,
    handleClose,
    isInteractiveModal
  } = _ref;
  const showHeader = !!title || closeable;
  const icon = headerIcon || defaultIcon;
  let titleContent;
  if (showHeader) {
    titleContent = /*#__PURE__*/React.createElement(HeaderWrapper, {
      className: "ui-modal-header-wrapper"
    }, icon && /*#__PURE__*/React.createElement(ResizedHeaderIcon, null, icon), title && /*#__PURE__*/React.createElement(Title, {
      isString: typeof title === 'string',
      id: headerId,
      className: "ui-modal-header-title"
    }, title), closeable && isInteractiveModal && /*#__PURE__*/React.createElement(CloseButtonDiv, null, /*#__PURE__*/React.createElement(Button, {
      ghost: true,
      size: "small",
      group: "circle",
      className: "ui-modal-close-btn",
      "aria-label": "Close Dialog",
      name: "ui-modal-close-btn",
      onClick: handleClose
    }, /*#__PURE__*/React.createElement(CancelIcon, null))));
  } else if (!title && ariaLabel) {
    titleContent = /*#__PURE__*/React.createElement(AriaLabel, {
      id: headerId,
      "data-testid": "aria-hidden-label",
      className: "ui-modal-hidden-label"
    }, ariaLabel);
  }
  return titleContent || null;
};
const Title = /*#__PURE__*/styled.h2.withConfig({
  displayName: "ModalTitle__Title",
  componentId: "sc-185rivx-0"
})(["flex:1 0;font-size:20px;font-weight:600;", ""], _ref2 => {
  let {
    isString
  } = _ref2;
  return isString && css(["padding-left:10px;"]);
});
const AriaLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalTitle__AriaLabel",
  componentId: "sc-185rivx-1"
})(["visibility:hidden;max-height:0;height:0;"]);
const HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalTitle__HeaderWrapper",
  componentId: "sc-185rivx-2"
})(["padding:0 10px 0 20px;display:flex;justify-content:flex-end;align-items:center;min-height:50px;border-bottom:1px solid ", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return (theme === null || theme === void 0 ? void 0 : theme.borderColor) || alto;
});
const ResizedHeaderIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalTitle__ResizedHeaderIcon",
  componentId: "sc-185rivx-3"
})(["svg{width:25px;height:25px;margin:0 0 0 6px;}"]);
const CloseButtonDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalTitle__CloseButtonDiv",
  componentId: "sc-185rivx-4"
})(["flex:0 0;margin-right:5px;font-size:12px;min-width:40px;button{border:0;&:hover,&:focus,&:active{border-radius:25px;}}"]);
export default ModalTitle;